/* eslint-disable react/prop-types */
import React from "react";
import { createContext, useState } from "react";

const AuthContext = createContext({
    auth: null,
    setAuth: () => { }
});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext